// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import { router } from './router';
import iView from 'iview';
import locale from 'iview/dist/locale/zh-TW';
import 'iview/dist/styles/iview.css';
import 'font-awesome/css/font-awesome.css';
import $ from 'jquery'
import "flexslider";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap'





Vue.config.productionTip = false
Vue.use(iView, { locale });

Vue.config.ignoredElements = ['gcse:search']; // google 站內搜尋

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js